import React, { useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import '../Footer/Footer.css';
import LogoWhite from '../../images/logoW.svg';


function Footer (){
  const navigate = useNavigate();
  
    return (
        <footer className="footer">
 
            <div className="footer-area">
              <p className="footer-description">
                VixAcademy is an online learning platform offering practical, career-focused courses in web development, programming, digital design, SEO, social media marketing, Google Services(Sites) and trading fundamentals.
                <span className="footer-description">
                Contact us for further inquiries or assistance from our contact page or by mail support@vixacademy.com
                </span>
              </p>
              <p className="footer-description">
                <b>Disclaimer:</b> The Trading Fundamentals Program is provided for educational and informational purposes only and does not constitute financial, investment, legal, or tax advice. Trading and investing involve risk and may result in loss of capital. Past performance is not indicative of future results.
              </p>
            </div>
            <div className="footer-links">
              <ul className="">
                <li>
                  <img src={LogoWhite} className="footerLogo" alt="VixAcademy Logo" onClick={() => navigate("/")} />
                </li>
                <ul>
                    <li  style={{borderRight: "1px solid white"}} onClick={() => navigate("/terms")}>Terms & Conditions </li>
                    <li  style={{borderRight: "1px solid white"}} onClick={() => navigate("/privacy")}>Privacy & Cookies Policy </li>
                    <li  style={{borderRight: "1px solid white"}} onClick={() => navigate("/contactus")}>Contact Us</li>
                </ul>

              </ul>
              <div className="footer-description centered gray">
                ©2025 VixAcademy. All rights reserved. 
              </div>
            </div>
{/*             <div className="footer-description centered gray">
                ©2025 VixAcademy. All rights reserved. 
            </div> */}
        </footer>
      )
  }
  



export default Footer